export const PERMISSIONS = {
  SUPPORT: {
    sidebar: ['farmers', 'bulk_onboard', 'reports', 'bookings', 'field_officers', 'logs', 'anomaly_logs', 'lab_dashboard', 'lab_performance', 'lab_crew', 'lab_work_logs', 'lab_targets', 'lab_task_hours', 'reagents', 'stock', 'calculator', 'raw_chemicals', 'orders', 'test_capacity', 'lab_reports', 'audit_log', 'partners', 'device', 'device_hw_version', 'device_sw_version', 'export', 'recommendations', 'Parameter-Formula', 'nutrient_calculator', 'electronic-components', 'hardware', 'hardware-order', 'hardware-capacity', 'farms_map', 'map_devices', 'it_logs_group', 'issue_management', 'farms', 'clinics', 'product_orders', 'add_product', 'product_list'],
    farmers: ['partner', 'report_count', 'book', 'add', 'view', 'update'],
    farms: ['add', 'satellite'],
    reports: ['view', 'create', 'update', 'download', 'followup', 'lock', 'test_partner', 'source', 'track', 'lock', 'disclaimer', 'bulk_update'],
    fieldOfficers: ['view', 'farmers', 'reports', 'samples', 'update'],
    bookings: ['update'],
    practices: ['add'],
    recommendations: ['view', 'edit'],
    clinics: ['add'],
  },
  PARTNER: {
    sidebar: ['dashboard', 'farmers', 'bulk_onboard', 'reports', 'bookings', 'field_officers', 'device', 'export', 'farms', 'clinics', 'product_orders', 'add_product', 'product_list'],
    farmers: ['book', 'add', 'view', 'update'],
    farms: ['add', 'satellite'],
    reports: ['view', 'followup'],
    fieldOfficers: ['view', 'reports', 'samples', 'update'],
    bookings: ['treatment', 'update'],
  },
  FIELD_OFFICER: {
    sidebar: ['farmers', 'reports', 'bulk_onboard', 'bookings', 'device', 'export', 'raise_issue', 'farms', 'product_orders'],
    farmers: ['book', 'add', 'view', 'update'],
    bookings: ['treatment','update'],
    reports: ['view', 'followup', 'disclaimer'],
    farms: ['add'],
    practices: ['add'],
  },
  FARMER: {
    sidebar: ['reports', 'bookings'],
    reports: ['view', 'disclaimer'],
    bookings: ['book', 'entity_id'],
  }
};

export const PARTNER_CATEGORIES = [
  { value: 'csr', label: 'CSR' },
  { value: 'ngo', label: 'NGO' },
  { value: 'agri_retailer', label: 'Agri Retailer' },
  { value: 'internal_team', label: 'Internal Team' },
  { value: 'government_institutions', label: 'Government Institutions' },
];

export const CSR_CATEGORIES = ['csr', 'ngo'];